import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "reactions-user-left" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "reactions-user-texts" }
const _hoisted_4 = { class: "reactions-user-name" }
const _hoisted_5 = {
  key: 0,
  class: "reactions-remove-reaction"
}
const _hoisted_6 = { class: "" }

import { Chat } from "@/store/chats/types";
import { useComputedValue } from "@/composables";
import { ActionTypes, GetterTypes } from "@/store";
import { computed } from "vue";
import { useStore } from "vuex";
import { Profile } from "@/store/auth/state";
import EmojiItem from "@/components/cards/EmojiItem/EmojiItem.vue";
import { ReactionsItemUser } from "@/types/chat";

interface MessageReactionsModalItemProps {
  user: ReactionsItemUser;
  emoji: string;
  isMine: boolean;
  messageId: string;
}

interface Emits {
  (e: "closeModal"): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageReactionsModalItem',
  props: {
    user: {},
    emoji: {},
    isMine: { type: Boolean },
    messageId: {}
  },
  emits: ["closeModal"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const profile = useComputedValue<Profile>(GetterTypes.GET_AUTH_PROFILE);
const { dispatch } = useStore();
const props = __props;
const chat = useComputedValue<Chat>(GetterTypes.GET_SELECTED_CHAT);
const chatId = computed(() => chat.value.id);

const closeModal = () => {
  emit("closeModal");
};

const removeReaction = async () => {
  if (!props.isMine) {
    return;
  }

  closeModal();
  await dispatch(ActionTypes.REMOVE_MESSAGE_REACTION, {
    messageId: props.messageId,
    chatId: chatId.value,
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "reactions-user",
    onClick: removeReaction
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "reactions-user-picture",
        src: _ctx.user.picture,
        alt: "person"
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.user.name), 1),
        (_ctx.isMine)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t("chat.chatContainer.messages.reactions.removeWithClick")), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(EmojiItem, {
        size: 28,
        emoji: _ctx.emoji
      }, null, 8, ["emoji"])
    ])
  ]))
}
}

})